import { createSelector } from '@reduxjs/toolkit';
import { State } from '../../../store/state';

export const errorCodeSelector = (state: State) => state.warehouse.errorCode;
export const warehouseSelector = (state: State) => state.warehouse.warehouse;

const warehousesIdsSelector = (state: State) => state.warehouse.warehouses.ids;
const warehousesEntitiesSelector = (state: State) =>
  state.warehouse.warehouses.entities;
export const warehousesSelector = createSelector(
  [warehousesIdsSelector, warehousesEntitiesSelector],
  (ids, entities) => ids.map((id) => entities[id])
);